<template>
  <div>
    <leftSideBar :anchor="anchor"></leftSideBar>
    <SideBar></SideBar>
    <div class="page-box">
      <div class="main">
        <div class="secure-block">
          <h3 class="rescue-bigtitle"
              id="one">远程咨询（第二诊疗意见），海外专家为您提供一对一的咨询</h3>
          <h4 class="rescue-title">什么是第二诊疗意见？</h4>
          <div class="secure-reason"
               style="margin-bottom:100px;">
            <div style="display:inline-block;width:600px;">
              <p class="secure-note">第二诊疗意见，英文为Second opinion，指患者听取现在的主治医生的见解以外，听取其他医生或医院的见解的行为。</p>
              <p class="secure-note">在日本、欧美等发达国家，第二诊疗意见是一项比较普遍的咨询方式。特别是被诊断为重大疾病或治疗重大疾病时，为了能更好的选择适合的治疗方法，对进行当中的治疗进行评估或对今后的治疗方案进行选择时，可以听取主治医生以外的其他医生或医院的意见。主治医生的见解就是第一诊疗意见。</p>
              <p class="secure-note">第二诊疗意见的目的不是为了更换主治医生，转院或接受治疗。是以听取其他医生或医院的意见为目的。</p>
            </div>
            <img :src="reason1"
                 alt=""
                 style="width: 300px; margin-left: 18px;">
          </div>
          <h4 class="rescue-title" id="smywxse">什么样的人需要第二诊疗意见？</h4>
          <div class="secure-reason"
               style="margin-bottom:100px;">
            <div style="width:598px;">
              <p class="secure-note">1. 当患者被诊断为严重疾病，如癌症时，对第一诊疗结果不确信，希望得到权威专家或者第二家医疗机构的诊断意见。</p>
              <p class="secure-note">2. 正在进行的治疗方案和效果一直不明显或者不理想。或者现有治疗会产生很大副作用。或者当第一诊疗意见为手术且手术风险很高，甚至会影响个人生活的情况下，患者不愿盲目手术，需要征求第二家医院意见。</p>
              <p class="secure-note content_class">3. 多家医院诊断及治疗意见不一致，导致患者难以进行医疗决策。或者长期无法确诊、国内医疗技术等限制，被建议国外寻求新医疗技术。</p>
            </div>
            <img :src="reason2"
                 alt=""
                 style="width: 287px; height:246px;">
          </div>
          <h4 class="rescue-title"
              id="two">对于患者的重大意义</h4>
          <div class="check-block">
            <h5 class="check-title">
              <span>理由1</span>可以减少误诊</h5>
            <div class="check-con">
              <div>
                <p>比如，肺部检查发现3 毫米的结节，国内大多数医生会建议先切除并做活检。但是很多时候会发现切出来的结果是良性，并不需要切除。这样的不必要的切除，对人体的负担大，降低生活的质量。因此，国外大多数专家会建议先观察，根据它的形状，部位，颜色等综合判断恶性的可能性是否高。如果恶性的可能性较低，会建议定期复查，观察变化。
                </p>
                <p>恶性肿瘤的治疗，对其类型的诊断尤为重要。根据肿瘤类型不同，所用的药物也不同。但是部分罕见的肿瘤或无法分类的肿瘤，对其诊断会有不同结果，很容易误诊用药不当，耽误治疗。</p>
              </div>
            </div>
          </div>
          <div class="check-block">
            <h5 class="check-title">
              <span>理由2</span>可以找到适合的方法</h5>
            <div class="check-con">
              <div>
                <p>一般来讲外科医生倾向手术，内科医生倾向化疗，放射线医生倾向放疗，并且容易受限于医生所在的医院的技术和设备。到底哪个是适合患者的治疗方法呢？这就需要咨询其他专家的意见了。</p>
                <p>比如，70岁的老人患了早期胃癌，医院会推荐手术。那是做开腹手术呢，还是腹腔镜手术呢，还是内视镜手术呢？虽然都可以治好病，但是对患者本人的负担以及术后的康复速度是完全不一样的。</p>
              </div>
            </div>
          </div>
          <div class="check-block"
               style="margin-bottom: 100px;">
            <h5 class="check-title">
              <span>理由3</span>可以加深对治疗方案的理解</h5>
            <div class="check-con">
              <div>
                <p>对主治医生的治疗方案不是很理解或有抵触时，也可以进行第二诊疗意见咨询。即使第二诊疗意见和主治医生的意见是一样的，也可以从别的角度加深对治疗方案的理解，取消抵触情绪，积极配合治疗。</p>
              </div>
            </div>
          </div>
          <h4 class="rescue-title"
              id="three">服务内容</h4>
          <div class="secure-reason"
               style="margin-bottom:68px;">
            <!-- <div style="display:inline-block">
                        <p class="secure-note">1.威马捷医疗咨询顾问的咨询服务</p>
                        <p class="secure-note">2.整理患者以往的医疗信息，筛出必要的资料并翻译</p>
                        <p class="secure-note">3.预约专家，医院</p>
                        <p class="secure-note">4.远程咨询（含医院费用）</p>
                        <p class="secure-note">5.专业医疗翻译（口译）</p>
                    </div>  -->
            <img :src="reason3"
                 alt=""
                 style="margin-top:-80px; width:100%;">
          </div>
          <h4 class="rescue-title"
              id="four">咨询流程</h4>
          <img src="../assets/images/medicine/reason100.png"
               style="display:block; margin: 0 auto;"
               alt="">
          <!-- <div class="consultation-process">
                    <h5>咨询威马捷</h5>
                    <p>请以电话或电子邮件的形式向医疗咨询顾问进行咨询，简单介绍患者的情况。</p>
                </div>
                <div class="consultation-process">
                    <h5>了解服务内容</h5>
                    <p>专业的医疗咨询顾问以邮件形式向客人发送服务介绍，咨询流程以及收费标准。</p>
                </div>
                <div class="consultation-process">
                    <h5>提交资料</h5>
                    <p>服务申请表（由威马捷提供），有关个人信息保护的同意书（由威马捷提供），患者本人护照复印件（没有护照时，可以后补）</p>
                    <p>医疗信息，各种影像资料（CT，MRI，PET等；需提供1个月以内的DICOM形式的电子版）</p>
                </div>
                <div class="consultation-process">
                    <h5>支付服务费</h5>
                    <p>威马捷向客人发送请款书（Invoice），收到请款书后，请按请款书里的账户信息办理汇款。</p>
                </div>
                <div class="consultation-process">
                    <h5>预约专家，医院</h5>
                    <p>根据客人指定的专家，预约日期。</p>
                </div>
                <div class="consultation-process">
                    <h5>进行远程咨询（威马捷代诊，亲属代诊，视频咨询）</h5>
                    <p>威马捷代诊：由威马捷提供根据提前收到的咨询内容咨询的结果报告。</p>
                    <p>亲属代诊：由威马捷安排专业医疗翻译人员提供全程口译服务。</p>
                    <p>视频咨询：需到威马捷北京本部或上海分公司进行，咨询时间最长不超过45分钟。
                    </p>
                </div> -->
        </div>
      </div>

      <div class="main recommend"
           style="width:980px;margin-top: 120px;">
        <h5 class="secure-title title03"
            id="doctor"> 推荐医生
          <router-link class="ccc" to="/doctorList/1" target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="doctor-list">
          <template v-for="(d,index) in list">
            <router-link :key="index"
                         target="_blank"
                         :to="{name: 'DoctorInfo',params:{ id: d.id} }"
                         class="doctor text-center">
              <span class="doctor-label">推荐专家</span>
              <div class="doctor-pic-box">
                <img class="doctor-avatar"
                     :src="baseURL + d.avatar"
                     alt="" />
              </div>
              <h5 class="doctor-name"> {{d.name.split("（")[0]}}<br/> {{d.name.split("（")[1]?'（'+d.name.split("（")[1]:''}}</h5>
              <div class="doctor-titles">
                <span class="doctor-title"
                      v-for="(dd,i) in d.department_name"
                      :key="i">{{dd}}</span>
              </div>
              <p class="doctor-skill show-overflow">
                {{d.easy_brief}}
              </p>
            </router-link>
          </template>
        </div>

        <h5 class="secure-title title01"
            id="hospital">合作医院
          <router-link to="/hospitalList/yczx/0"
                       class="ccc"
                       target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="secure-hospital">
          <router-link v-for="(hos, index) in hospitals"
                       :to="'/hospitalInfo/' + hos.id"
                       target="_blank"
                       :key="index">
            <img class="hospital-img"
                 :src="baseURL + hos.hospital_img"
                 alt="">
            <div class="hospital-content">
              <h6 class="hospital-name"
                  v-html="hos.name"></h6>
              <p class="hospital-info">{{hos.easy_brief}}</p>
            </div>
          </router-link>
        </div>
        <h5 class="secure-title title02"
            id="cases"
            style="padding-top:70px;">服务案例
          <router-link to="/successCase/3"
                       class="ccc"
                       target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="fw-bg">
          <div class="medicine-case"
               v-for="(c,index) in cases"
               :key="index">
            <router-link target="_blank" :to="{name: 'successCaseDetail',params:{ id: c.id} }">
              <div class="case-info">
                <h5 class="case-info_text">{{c.title}}</h5>
                <p class="case-ill">
                  <span>疾病：{{c.disease_name}} </span>
                  <span class="b">{{c.alias}} <br/>{{c.age}} 岁</span>
                </p>
                <!-- <p class="case-topic">摘要： {{c.desc}}</p> -->
              </div>
            </router-link>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import reason1 from "@/assets/images/medicine/reason15.png"
import reason2 from "@/assets/images/medicine/reason16.png"
import reason3 from "@/assets/images/medicine/reason17.png"

// import title-icon1 from "@/assets/images/home/title-icon1.png"
import map from "@/assets/images/home/icon-link1.png"
import leftSideBar from "@/components/LeftSideTitleBar.vue"
import SideBar from "@/components/SideBar"
import * as apis from '@/api/hospital'
import * as doctor from '@/api/doctor'
import * as cases from '@/api/success'
import { baseURL } from "@/api/axios"
export default {
  data () {
    return {
      baseURL,
      reason1,
      reason2,
      reason3,
      map,
      countries: [],
      cases: [],
      list: [],
      hospitals: [],
      anchor: [
        { title: '什么是第二诊疗意见', id: 'one' },
        { title: '什么样的人需要第二诊疗意见', id: 'smywxse' },
        { title: '第二诊疗意见的意义', id: 'two' },
        { title: '服务内容', id: 'three' },
        { title: '咨询流程', id: 'four' },
        { title: '推荐医生', id: 'doctor' },
        { title: '合作医院', id: 'hospital' },
        { title: '服务案例', id: 'cases' },

      ]
    }
  },
  components: {
    leftSideBar,
    SideBar
  },
  mounted () {
    this.getHospitalList();
    this.getList(1);
    this.getSuccessList();
  },
  methods: {
    async getHospitalList () {
      try {
        let data = {
          hospital_type_id: 3,
          //远程咨询 1
          state_id: undefined,
          area_id: undefined,
          department_id: undefined,
          disease_id: [],
          keyword: undefined,
          page: 1
        }
        let res = await apis.getAllHospitalList(data);
        if (res.code == 200) {
          let rs = res.data.data.map(item => {
            return {
              ...item,
              info: this.getSimpleText(item.easy_brief)
            }
          });
          if (rs.length > 6) {
            this.hospitals = rs.slice(0, 6);
          } else {
            this.hospitals = rs;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    async getList (index) {
      try {
        let data = {
          page: index,
          // ...this.hospital
          name: '',
          state_id: 0,
          area_id: 0,
          disease_id: 0
        };
        let res = await doctor.getAllDoctors(data);
        if (res.code == 200) {
          if (res.data.data.length > 6) {
            this.list = res.data.data.slice(0, 6);
          } else {
            this.list = res.data.data
          }

          // this.total = res.data.total;
          // window.scrollTo(0,0);
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getSuccessList () {
      try {
        let data = {
          page: 1,
          id: 0,
          disease_id: 0,
          type_id: 3
        }
        let res = await cases.getSuccessCaseList(data);
        if (res.code == 200) {
          this.cases = res.data.data.slice(0, 3);
        }
      } catch (e) {
        console.log(e)
      }
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.bg-white {
  background: #fff;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}
.secure-block {
  width: 980px;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 30px;
  margin: 20px auto 50px;
}
.secure-title {
  font-size: 24px;
  color: #000;
  line-height: 28px;
  padding-left: 40px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 28px auto;
  margin-bottom: 45px;
  a {
    float: right;
    color: #333130;
  }
}
.ccc:hover {
  color: #2d8cf0!important;
}
.title03 {
  background: url('../assets/images/home/hzys-icon.png') no-repeat left center;
  background-size: 28px 28px;
  a {
    font-size: 24px;
  }
}
.title01 {
  background: url('../assets/images/home/hzyy-icon.png') no-repeat 0 107px;
  background-size: 28px 28px;
  a {
    font-size: 24px;
  }
}
.title02 {
  background-image: url('../assets/images/home/fwal-icon.png');
  background-position: 0 70px;
  background-size: 28px 28px;
}
.secure-reason {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}
.secure-note {
  font-size: 16px;
  color: #000;
  line-height: 32px;
}
.secure-specials {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 72px;
  p {
    width: 234px;
    height: 65px;
    background: #ae1e10;
    color: #fff;
    font-size: 24px;
    line-height: 65px;
    text-align: center;
  }
}
.doctor {
  position: relative;
  width: 310px;
  height: 430px;
  background: #fff;
  padding: 20px 10px 40px;
  margin-bottom: 25px;
  .doctor-label {
    position: absolute;
    left: 6px;
    top: 15px;
    display: inline-block;
    width: 87px;
    height: 37px;
    background: url('../assets/images/doctor/icon.png') no-repeat center;
    color: #fff;
    font-size: 14px;
    line-height: 37px;
  }
  .doctor-pic-box {
    width: 130px;
    height: 130px;
    margin: auto;
    // background: red;
    // border-radius: 50%;
    // margin-bottom: 36px;
    // margin: 0 auto 36px auto;
    // overflow: hidden;
  }
  .doctor-avatar {
    width: 100%;
  }
  .doctor-name {
    font-size: 22px;
    color: #333130;
    line-height: 40px;
    margin-bottom: 28px;
  }
  .doctor-titles {
    height: 32px;
    overflow: hidden;
    margin-bottom: 15px;
  }
  .doctor-title {
    font-size: 12px;
    color: #333130;
    line-height: 28px;
  }
  .doctor-skill {
    font-size: 14px;
    color: #333130;
    line-height: 18px;
    span {
      color: #d23224;
    }
  }
  .doctor-pointer {
    margin: 140px 0 70px;
  }
}
.secure-hospital {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 32px;
  a {
    display: block;
    width: 302px;
    min-height: 396px;
    background: #fff;
    border: 1px solid #dcdcdc;
    margin-bottom: 32px;
    margin-right: 37px;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
  .hospital-img {
    width: 300px;
    height: 220px;
    margin-bottom: 25px;
  }
  .hospital-name {
    min-height: 47px;
    font-size: 18px;
    color: #333130;
    line-height: 24px;
    margin-bottom: 15px;
    padding: 0 10px;
  }
  .hospital-info {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    color: #9b9898;
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px;
  }
}
// .qualify{
//     padding: 50px 0 60px;
// }
// .qualify-title{
//     font-size: 24px;
//     color: #000;
//     text-align: center;
//     margin: 40px 0;
// }
.secure-zizhi {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 66px;
  .qualifications {
    img {
      width: 163px;
      height: 226px;
      margin-bottom: 35px;
    }
    p {
      font-size: 16px;
      color: #ae1e10;
      line-height: 20px;
      text-align: center;
    }
  }
}
.user-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .secure-user {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 110px;
    border: 1px solid #dcdcdc;
    background: #fff;
    img {
      width: 60px;
      height: 60px;
      margin-right: 18px;
    }
    p {
      font-size: 28px;
      color: #ae1e10;
    }
  }
}

.medicine-case {
  width: 100%;
  border: 1px solid #ececec;
  padding: 34px 54px 34px 27px;
  .case-img {
    width: 237px;
    height: 177px;
    margin-right: 34px;
  }
  .case-info_text {
    width:500px;
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
  }
  .case-info {
    position: relative;
    display: block;
    // width: 610px;
    // vertical-align: top;
    h5 {
      font-size: 20px;
      color: #373737;
      font-weight: normal;
      line-height: 26px;
      margin-bottom: 10px;
      position: absolute;
      p {
        display: inline-block;
        font-size: 16px;
      }
    }
    .case-ill {
      font-size: 18px;
      color: #cf1300;
      line-height: 22px;
      // background: url("../assets/images/medicine/line.jpg") repeat-x bottom;
      // padding-bottom: 16px;
      // margin-bottom: 18px;
    }
    .case-topic {
      font-size: 14px;
      color: #585858;
      line-height: 30px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.check-block {
  border: 1px solid #dfdfdf;
  margin-bottom: 30px;
}
.check-title {
  position: relative;
  background: #e9ebf4;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  padding-left: 112px;
  overflow: hidden;
  z-index: 9999;
  &::before {
    position: absolute;
    left: 130px;
    top: 0;
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-width: 37px 0px 28px 25px;
    border-style: solid;
    border-color: #e9ebf4;
    transform: translateX(-50px) rotate(23deg);
    z-index: 9;
  }
  span {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 96px;
    background: #ae1e10;
    color: #fff;
    text-align: center;
    text-indent: -10px;
  }
}
.check-con {
  display: flex;
  flex-direction: row;
  height: 244px;
  justify-content: space-between;
  padding: 20px 20px 30px 20px;
  p {
    font-size: 16px;
    color: #797576;
    line-height: 32px;
    color: #333;
  }
}
.consultation-process {
  position: relative;
  border: 1px solid #ae1e10;
  background: rgb(249, 219, 210);
  padding: 20px 40px 10px;
  margin: 40px 0;
  h5 {
    position: absolute;
    left: 30px;
    top: -20px;
    width: 600px;
    height: 40px;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ae1e10;
    font-size: 20px;
    line-height: 40px;
    text-indent: 20px;
  }
  p {
    font-size: 16px;
    line-height: 30px;
  }
}
.medicine-case .case-info .case-ill .b {
  color: #333;
  line-height: 34px;
}
.content_class {
  text-align: justify;
  -ms-text-align-last: justify;
  -moz-text-align-last: justify;
  text-align-last: start;
  word-break: break-all;
  text-justify: distribute;
}
</style>
